<template>
    <div class="color-selector-wrap">
      <div
        class="color-selector"
        :style="{ backgroundColor: selectedColor, justifyContent: selectedColor == '' ? 'space-between' : 'flex-end' }"
        @click="toggleColors()"
      >
        <i :class="{rotate: isOpened}" class="chevron icon-chevron-down"></i>
      </div>
      <div class="color-dropdown" v-show="isOpened">
        <button
          v-for="(color, index) in colors"
          :key="index"
          @click="selectElementColor(color)"
          :style="{ backgroundColor: color }"
        >
          <span v-if="color == ''" style="color: #fff">None</span>
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "ColorSelector",
    data() {
      return {
        isOpened: false,
        selectedColor: '#838E9A',
        colors: ['#838E9A', '#EC9D4F', '#4C729A', '#D45B43', '#56B9F3', '#DE6179', '#585FC8', '#59C174', '#9989F7', '#68BA49'],
      };
    },
    props: ['defaultColor'],
    mounted() {
      if (this.defaultColor) this.selectedColor = this.defaultColor
    },
    methods: {
      toggleColors() {
        this.isOpened = !this.isOpened;
      },
      selectElementColor(color) {
        this.selectedColor = color;
        this.isOpened = false;
        this.$emit("color-selected", this.selectedColor);
      },
    },
  };
  </script>
  
<style lang="scss">
  .color-selector-wrap {
    position: relative;
  }
  .color-selector {
    width: 87px;
    height: 30px;
    flex-shrink: 0;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: var(--primary-bg);
    border: 0.5px solid var(--outline);
    cursor: pointer;
    i {
      transition: 0.3s ease-in;
      color: #ffff;
      font-size: 4px;
      margin-right: 10px;
    }
    .chevron.rotate {
      transform: rotate(180deg);
    }
    .none-selected {
      margin-left: 10px;
      font-size: 14px;
    }
  }

  .color-dropdown {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 3px 4px;
    position: absolute;
    top: 33px;
    z-index: 99;
    width: 92px;
    // height: 177px;
    padding: 6px 3px;
    border-radius: 6px;
    background: var(--primary-bg);
    border: 0.5px solid var(--outline);
    backdrop-filter: blur(6px);
    & button {
        width: 40px;
        height: 30px;
        border-radius: 3px;
        border: none;
        cursor: pointer;

        &:hover, &.active {
            outline: 0.5px solid #ffffff;
        }
    }
  }
</style>
